var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"selectIndex":1}},[_c('carousel'),_c('overview-three',{attrs:{"range":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }